// Chair massage (corporate) — 90$/heure, à la carte de 15 min à 60 min.
export const CHAIR_MASSAGE = {
    hourlyRate: 90,
    options: [
        { id: "chair-15", duration: 15, price: 22.50 },
        { id: "chair-30", duration: 30, price: 45 },
        { id: "chair-45", duration: 45, price: 67.50 },
        { id: "chair-60", duration: 60, price: 90 },
    ],
    details: {
        deroulement:
            "J'arrive sur votre lieu de travail (bureau, salle de repos, salon d'accueil) avec une chaise ergonomique professionnelle. Chaque employé s'installe habillé, sans huile, et bénéficie de 15 à 30 minutes de travail ciblé sur le haut du corps : nuque, trapèzes, épaules, dos et bras. La rotation est planifiée à l'avance pour minimiser l'interruption des équipes. Aucune installation lourde, aucun nettoyage à prévoir.",
        bienfaits: [
            "Réduction immédiate des tensions liées au travail sur écran",
            "Améliore la concentration et diminue le stress ressenti",
            "Renforce la culture bien-être et la marque employeur",
            "Format flexible : 2 h à une journée complète",
            "Facturation entreprise avec reçu conforme",
        ],
    },
};

// Massage sur chaise individuel (à domicile ou en clinique, 30-45 min).
// Prix sur demande — bouton "Demander un devis" uniquement.
export const CHAIR_INDIVIDUAL = {
    id: "chair-individuel",
    name: "Massage sur Chaise Individuel",
    subtitle: "À domicile ou en clinique · 30 à 45 min",
    duration: "30 à 45 min",
    quoteOnly: true,
    description:
        "Séance individuelle sur chaise ergonomique — à votre domicile ou en clinique. Cible le haut du corps (dos, épaules, nuque, bras) en séance courte et efficace. Idéal en soirée, entre deux rendez-vous, ou pour un premier contact avec la massothérapie. Tarif sur demande selon lieu et durée.",
    slug: "massage-chaise-individuel",
};

// Home service surcharge
export const HOME_SERVICE = {
    surcharge: 20,       // Supplément à l'unité par séance à domicile
    radiusKm: 40,        // Rayon desservi depuis Blainville
};

// Services supplémentaires — hors carte principale, disponibles à la demande.
// Le Massage Yoga Thaï est offert exclusivement en clinique.
export const ADDITIONAL_SERVICES = [
    {
        id: "yoga-thai",
        name: "Massage Yoga Thaï",
        subtitle: "Étirements assistés · en clinique uniquement",
        duration: "60 min",
        price: 100,
        highlight: true,
        description:
            "Massage thaï traditionnel : étirements assistés, pressions rythmées, travail des lignes d'énergie. Pratiqué habillé (vêtements confortables). En clinique uniquement.",
        slug: "massage-thai",
    },
];
